var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFill = function SvgStarFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#C29B40",
    viewBox: "0 0 25 23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#starFill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.096 1.366a1.33 1.33 0 0 0-1.2-.764c-.513 0-.975.297-1.2.764l-2.68 5.62-5.983.901c-.5.076-.916.433-1.07.922a1.39 1.39 0 0 0 .329 1.389l4.341 4.38-1.025 6.189c-.083.51.125 1.028.538 1.33.412.301.958.34 1.408.097l5.346-2.91 5.346 2.91c.45.242.996.209 1.408-.097.413-.306.62-.82.538-1.33l-1.03-6.19 4.342-4.38c.358-.36.488-.9.33-1.388a1.34 1.34 0 0 0-1.072-.922l-5.987-.9z",
    opacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "starFill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.892.602h24v21.75h-24z"
  })))));
};
export default SvgStarFill;